var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _polygon, _path10, _polygon2, _path11, _polygon3, _path12, _path13, _path14, _path15, _path16, _path17, _circle2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle3, _path25, _path26, _path27, _path28, _path29, _circle4, _path30, _path31, _path32, _path33, _path34, _circle5, _path35, _path36, _path37, _path38, _path39, _circle6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _path40, _path41, _path42, _path43, _path44, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeasFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 389.67008,
    height: 551.52672,
    viewBox: "0 0 389.67008 551.52672",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.165,724.57336a1.18644,1.18644,0,0,0,1.18292,1.19H793.645a1.19,1.19,0,1,0,0-2.38H406.355a1.18648,1.18648,0,0,0-1.19,1.183Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M559.937,561.59326a44.3282,44.3282,0,0,1,12.82757-.69623,1.51155,1.51155,0,0,0,1.5-1.5,1.53147,1.53147,0,0,0-1.5-1.5,47.11382,47.11382,0,0,0-13.62506.8034,1.50038,1.50038,0,0,0,.79755,2.89283Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#ccc",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M456.96123,535.50018c-8.24878-10.97183-13.01645-23.24112-13.17267-37.22913a3.01824,3.01824,0,0,1,1.83652-3.84775l28.11624-9.9483a3.01819,3.01819,0,0,1,3.84772,1.83652l13.1727,37.22912a3.01817,3.01817,0,0,1-1.83649,3.84772l-28.11624,9.9483A3.01824,3.01824,0,0,1,456.96123,535.50018Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463.309,534.8366a3.01817,3.01817,0,0,1-3.84772-1.83648c-8.24884-10.97187-13.01648-23.24115-13.17273-37.22913a2.97929,2.97929,0,0,1-.11017-1.54346l-.55328.19574a3.01829,3.01829,0,0,0-1.83655,3.84772c.15625,13.988,4.92389,26.25726,13.17273,37.22913a3.01816,3.01816,0,0,0,3.84772,1.83648l28.11624-9.94824a3.00479,3.00479,0,0,0,1.94672-2.30426Z",
    transform: "translate(-405.16496 -174.23664)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M476.48122,506.97137l-18.82275,6.71878a1.19916,1.19916,0,0,1-.80628-2.25873l18.82275-6.71878a1.19916,1.19916,0,0,1,.80625,2.25873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M459.5887,506.01849l-4.141,1.47812a1.19917,1.19917,0,1,1-.81338-2.2562l.00714-.00253,4.141-1.47812a1.19916,1.19916,0,0,1,.80624,2.25873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M480.02571,516.90133,461.203,523.62011a1.19916,1.19916,0,0,1-.80624-2.25873l18.82275-6.71878a1.19917,1.19917,0,0,1,.81338,2.2562Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M478.25347,511.93637l-18.82276,6.71878a1.19917,1.19917,0,0,1-.809-2.25779l.00269-.00094,18.82275-6.71878a1.19916,1.19916,0,0,1,.80625,2.25873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.76961,
    cy: 315.57171,
    r: 5,
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M641.93459,273.84832c.08,7.32,2.41,22.56.74,29.73l-.27-.6a32.90163,32.90163,0,0,1-4.41,2.95,21.13326,21.13326,0,0,0-4.9-7.2,25.29667,25.29667,0,0,1-1.17,9.96c-6.25,2.25-17.22-4.84-24.02-4.99-10.93994-.25-21.6-2.97-32.05-5.85-3.71-1.02-7.79-2.35-9.47-5.43s1.32672-6.40454,1.13-9.88c-1.40131-24.75567,10.39019-28.90518,21.61-35.52,2.46906-1.45569,3.68-4.59,6.47-5.81,3.87006-1.69,8.48-.88,12.69-.03a6.41294,6.41294,0,0,1-4.24-4.64,5.78524,5.78524,0,0,1,2.26-5.6c2.32-1.79,5.78-2.01,8.74-1.25a29.21094,29.21094,0,0,1,8.02,3.94,15.93028,15.93028,0,0,1,4.4,3.56,4.41181,4.41181,0,0,1,.52,5,5.71538,5.71538,0,0,1-4.47,2.17,14.95964,14.95964,0,0,1-3.94-.41,29.97258,29.97258,0,0,1,15.27,9.24C639.85457,259.01832,641.84456,266.52831,641.93459,273.84832Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M467.13512,344.393a9.15864,9.15864,0,0,0,11.96112,4.485,8.78569,8.78569,0,0,0,1.2666-.711l25.749,18.91809,14.19642-9.68811-38.0748-22.10187A9.13326,9.13326,0,0,0,471.41,332.61529a8.74047,8.74047,0,0,0-4.37646,11.56021v0Q467.08279,344.28494,467.13512,344.393Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M732.52462,327.22433a9.15866,9.15866,0,0,0-7.98334,9.97244,8.78487,8.78487,0,0,0,.28167,1.42493L698.83351,357.208l4.79114,16.5058,32.84967-29.31012a9.13319,9.13319,0,0,0,5.91382-9.45285,8.74047,8.74047,0,0,0-9.62518-7.75549Q732.64358,327.20824,732.52462,327.22433Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#ffb6b6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "138.897 533.902 130.527 533.831 126.823 500.797 139.175 500.901 138.897 533.902",
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M517.25374,721.44714a3.74674,3.74674,0,0,0,3.70978,3.7746l16.64014.13885,2.91308-5.90478,1.06989,5.93493,6.27868.05695L546.27986,704.28l-2.18444-.14532-8.91-.6142-2.87457-.1925-.05042,5.98913-13.367,9.06647A3.74054,3.74054,0,0,0,517.25374,721.44714Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.221 496.825 242.388 501.657 220.08 477.013 230.165 469.88 249.221 496.825",
    fill: "#ffb6b6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M640.40608,697.525a3.74672,3.74672,0,0,0,5.21613.89575l13.58545-9.6098-1.08594-6.49408,4.33594,4.19134,5.12872-3.62231L653.9319,666.6336l-1.85772,1.15839-7.58979,4.70746-2.44531,1.52331,3.45844,4.89-5.55072,15.168A3.74042,3.74042,0,0,0,640.40608,697.525Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "145.174 266.074 169.485 209.619 225.481 209.619 209.33 268.537 145.174 266.074",
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M498.93682,708.39172a2.26935,2.26935,0,0,1-1.64469-3.93335l.15549-.61817q-.03067-.07423-.0618-.14837a6.09415,6.09415,0,0,0-11.24139.04175c-1.8386,4.42816-4.17942,8.86389-4.7558,13.546a18.02843,18.02843,0,0,0,.3165,6.20044A72.28164,72.28164,0,0,1,475.13,693.45922a69.76673,69.76673,0,0,1,.43274-7.783q.35852-3.17779.99472-6.31036a73.11939,73.11939,0,0,1,14.50012-30.98962,19.45879,19.45879,0,0,0,8.093-8.39655,14.84337,14.84337,0,0,0,1.34992-4.05615c-.394.05169-1.48557-5.94867-1.18839-6.31677-.54907-.8332-1.53177-1.24732-2.13144-2.06037-2.98233-4.04339-7.09119-3.3374-9.23621,2.15729-4.58224,2.31268-4.62658,6.14807-1.815,9.83685,1.78879,2.3468,2.03455,5.52234,3.6041,8.03479-.1615.20673-.32944.407-.49091.61365a73.59075,73.59075,0,0,0-7.681,12.16858,30.59249,30.59249,0,0,0-1.82641-14.2096c-1.7482-4.21734-5.02491-7.76916-7.91047-11.415a6.2792,6.2792,0,0,0-11.184,3.08331q-.00888.08065-.0173.16119.64293.36264,1.25864.7699a3.07821,3.07821,0,0,1-1.24106,5.60175l-.06278.00964a30.627,30.627,0,0,0,.80735,4.57941c-3.70179,14.31579,4.29013,19.5299,15.70147,19.7641.2519.12915.49738.2583.74927.3811a75.11393,75.11393,0,0,0-4.04327,19.02777,71.24187,71.24187,0,0,0,.05166,11.50323l-.01937-.13562a18.82579,18.82579,0,0,0-6.42661-10.87023c-4.94562-4.06263-11.93283-5.55872-17.26825-8.82428a3.533,3.533,0,0,0-5.41122,3.43707l.02182.14264a20.67277,20.67277,0,0,1,2.31869,1.11731q.64288.36273,1.25864.76989a3.07825,3.07825,0,0,1-1.24109,5.60181l-.06281.00964c-.04519.00647-.084.01294-.12912.01941a30.65419,30.65419,0,0,0,5.63855,8.82923c2.31464,12.49713,12.256,13.6828,22.89023,10.04352h.00647A75.09176,75.09176,0,0,0,480.465,724.481h18.02021c.06463-.20019.12274-.40692.18091-.60718a20.47645,20.47645,0,0,1-4.9863-.297c1.337-1.64057,2.674-3.29413,4.011-4.93463a1.11029,1.11029,0,0,0,.084-.09687c.67816-.8396,1.36282-1.67285,2.041-2.51245l.00037-.001a29.99,29.99,0,0,0-.87875-7.63983Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#f2f2f2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M693.93233,708.39172a2.26933,2.26933,0,0,0,1.64471-3.93335l-.15551-.61817q.03075-.07423.06176-.14837a6.09415,6.09415,0,0,1,11.2414.04175c1.83856,4.42816,4.17944,8.86389,4.7558,13.546A18.02869,18.02869,0,0,1,711.164,723.48a72.28144,72.28144,0,0,0,6.57513-30.02076,69.762,69.762,0,0,0-.43274-7.783q-.35852-3.17779-.99469-6.31036a73.11843,73.11843,0,0,0-14.50012-30.98962,19.4591,19.4591,0,0,1-8.093-8.39655,14.844,14.844,0,0,1-1.34991-4.05615c.394.05169,1.48553-5.94867,1.18842-6.31677.54907-.8332,1.5318-1.24732,2.13147-2.06037,2.9823-4.04339,7.09118-3.3374,9.2362,2.15729,4.58222,2.31268,4.62659,6.14807,1.815,9.83685-1.78875,2.3468-2.03454,5.52234-3.60406,8.03479.1615.20673.32947.407.4909.61365a73.59229,73.59229,0,0,1,7.681,12.16858,30.59306,30.59306,0,0,1,1.82629-14.20954c1.74817-4.21734,5.0249-7.76916,7.91046-11.415a6.27919,6.27919,0,0,1,11.184,3.08331q.00888.08065.01734.16119-.64289.36264-1.25867.7699a3.0782,3.0782,0,0,0,1.24109,5.60175l.06274.00964a30.62309,30.62309,0,0,1-.80731,4.57941c3.70178,14.31579-4.2901,19.5299-15.70148,19.7641-.25189.12915-.49737.2583-.74927.3811a75.11568,75.11568,0,0,1,4.04328,19.02777,71.24544,71.24544,0,0,1-.0517,11.50324l.01941-.13562a18.82547,18.82547,0,0,1,6.42658-10.8703c4.94561-4.06263,11.9328-5.55872,17.26825-8.82428a3.533,3.533,0,0,1,5.41119,3.43707l-.02179.14264a20.6767,20.6767,0,0,0-2.31873,1.11731q-.64287.36273-1.25866.76989a3.07823,3.07823,0,0,0,1.24109,5.60181l.0628.00964c.04517.00647.084.01294.12909.01941a30.65419,30.65419,0,0,1-5.63855,8.82923c-2.31464,12.49713-12.256,13.6828-22.89026,10.04352h-.00647A75.0897,75.0897,0,0,1,712.404,724.481H694.38387c-.06464-.20019-.12274-.40692-.18091-.60718a20.4766,20.4766,0,0,0,4.98633-.297c-1.337-1.64057-2.674-3.29413-4.011-4.93463a1.11154,1.11154,0,0,1-.084-.09687c-.67816-.8396-1.3628-1.67285-2.041-2.51245l-.00036-.001a29.99046,29.99046,0,0,1,.87872-7.63983Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M550.33943,436.07116l-24.137,50.35175,1.72278,200.65716h20.67346s4.01984-5.42108,4.01984-9.2196-6.83728-4.34937-2.27912-9.012,6.07764-6.182,6.07764-10.74023V585.18408l16.30066-70.69162-1.72278,77.674,58.57477,69.909,13.64514-13.64514s3.99036-1.75879,0-5.53668-6.47882,2.89453-6.754-7.65887,2.00391-8.27424-.27514-10.55335S602.005,584.3197,602.005,584.3197s28.86267-122.97412,14.42835-146.52484Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M617.95284,441.59341s-62.29553-22.03134-57.73731-34.18656,12.215-9.81631,3.06873-13.64471-15.206-4.58813-9.51721-9.906,14.04547-10.63583,14.04547-15.95373,6.83734-47.10147,6.83734-47.10147h10.94549l11.08582-18.99252h15.66064l7.89014,17.47314h16.65961l.81354,26.58954s1.07672,51.36658-4.01984,53.41238-9.65479,2.04581-5.09656,6.604,7.15436,6.91507,5.09656,11.05453S617.95284,441.59341,617.95284,441.59341Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M627.06923,326.8785l9.82227-7.597s16.76727,0,19.04638,9.11642,15.99671,31.41046,15.99671,31.41046,13.63165-7.85971,18.94958-7.85971,9.1164,3.7985,9.1164-.7597-3.03882-5.3179,1.51941-5.3179,16.71344-4.5582,16.71344-4.5582l12.96576,12.96576s-1.57026,12.10437-6.88819,11.34467-8.35669-4.5582-8.35669,0,3.03882,11.3955-3.79852,12.15521-52.41937,12.15521-52.41937,12.15521l-31.14777-45.58209Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M587.56478,326.8785l-9.82227-7.597s-16.76727,0-19.04639,9.11642-16.76153,31.41046-16.76153,31.41046-12.86676-7.85971-18.18469-7.85971-9.1164,3.7985-9.1164-.7597,3.03882-5.3179-1.51941-5.3179-16.71344-4.5582-16.71344-4.5582l-12.96579,12.96573s1.57025,12.10437,6.88816,11.34467,8.35672-4.5582,8.35672,0-3.03882,11.3955,3.79849,12.15521,52.41937,12.15521,52.41937,12.15521l31.14777-45.58209Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.52552,
    cy: 99.20164,
    r: 24.24409,
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M629.14461,269.77831c-2.85,3.45-7.09,3.27-10.86,2.72-1.19-.17-2.38-.36-3.56994-.58-.21-.67-.45-1.34-.72-1.99a21.133,21.133,0,0,0-4.9-7.2,24.90479,24.90479,0,0,1-.61,7.93q-3.31494-.765-6.6-1.71a7.65517,7.65517,0,0,1-6.38-8.4c-3.15,2.4-6.58,4.48-10.18,4.52a9.49979,9.49979,0,0,1-8.9-6.93c-.98-3-.83-6.46-.43-9.7.48-3.85,1.56-8.08,4.16-9.63,2.09-1.26,4.5-.36,6.65.66a76.60614,76.60614,0,0,1,13.4,8.22l.05,1.05c1.08-5.17,4.65-9.16,8.54-9.56,2.62-.26,5.18.95,7.65,2.17a36.07745,36.07745,0,0,1,8.91,5.61,19.85677,19.85677,0,0,1,6.02,10.37C632.30458,261.65834,631.60457,266.79833,629.14461,269.77831Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M605.1454,236.1324c.24854.02087-.362-.11922-.16375-.03594a1.97589,1.97589,0,0,1-.27961-.1564c-.01525-.00974-.21228-.169-.08337-.05814a1.94635,1.94635,0,0,1-.64319-.8977,8.063,8.063,0,0,1-.37915-2.67115,8.44659,8.44659,0,0,0-.59546-3.48266,2.07884,2.07884,0,0,0-3.2749-.73033c-.81836.80241-.88312,2.158-.941,3.23617a10.42262,10.42262,0,0,0,.35114,3.323,9.53183,9.53183,0,0,0,2.91778,4.58308,9.97048,9.97048,0,0,0,5.77558,2.43819,1.5144,1.5144,0,0,0,1.06066-2.56065l-2.68414-2.54816a1.5,1.5,0,1,0-2.12134,2.12132l2.68415,2.54816,1.06067-2.56065a5.96582,5.96582,0,0,1-1.30323-.26627,5.02237,5.02237,0,0,1-1.30188-.57054,6.22683,6.22683,0,0,1-1.10858-.77493,8.56875,8.56875,0,0,1-.6228-.60607q-.1074-.11578-.21051-.23558c.00494.00575-.28241-.355-.159-.19a8.45986,8.45986,0,0,1-.80658-1.35135,3.41521,3.41521,0,0,1-.1969-.52116,7.9406,7.9406,0,0,1-.2326-.89678,7.79156,7.79156,0,0,1-.1026-1.93156,7.89481,7.89481,0,0,1,.08179-.8177,3.2511,3.2511,0,0,0,.0838-.43488c.00525-.36418-.04975.1945-.23963.27934l-.75708.20479a.82443.82443,0,0,1-.61676-.36108q-.04733-.18783.02674.0666a4.89567,4.89567,0,0,1,.132.60628,14.1603,14.1603,0,0,1,.10059,1.43345,14.25961,14.25961,0,0,0,.35175,3.01673,4.82952,4.82952,0,0,0,4.19726,3.8026,1.51211,1.51211,0,0,0,1.5-1.5A1.53067,1.53067,0,0,0,605.1454,236.1324Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M728.9612,333.50015c-8.24878-10.97184-13.01642-23.24112-13.17267-37.22913a3.01822,3.01822,0,0,1,1.83649-3.84775l28.11627-9.9483a3.01818,3.01818,0,0,1,3.84772,1.83652l13.17267,37.22912a3.01818,3.01818,0,0,1-1.83649,3.84772l-28.11627,9.9483A3.01819,3.01819,0,0,1,728.9612,333.50015Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M735.309,332.8366a3.01817,3.01817,0,0,1-3.84772-1.83648c-8.24884-10.97187-13.01648-23.24115-13.17273-37.22913a2.97961,2.97961,0,0,1-.11017-1.54346l-.55328.19574a3.01827,3.01827,0,0,0-1.83655,3.84772c.15625,13.988,4.92389,26.25726,13.17273,37.22913a3.01817,3.01817,0,0,0,3.84772,1.83648l28.11627-9.94824a3.00475,3.00475,0,0,0,1.94672-2.30426Z",
    transform: "translate(-405.16496 -174.23664)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M748.48122,304.97137l-18.82275,6.71878a1.19916,1.19916,0,0,1-.80628-2.25873l18.82275-6.71878a1.19916,1.19916,0,0,1,.80628,2.25873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M731.5887,304.01849l-4.141,1.47812a1.19917,1.19917,0,1,1-.809-2.25778l.00269-.00095,4.141-1.47812a1.19916,1.19916,0,0,1,.80627,2.25873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M752.02571,314.90133,733.203,321.62011a1.19917,1.19917,0,1,1-.809-2.25778l.00269-.00095,18.82275-6.71878a1.19916,1.19916,0,0,1,.80627,2.25873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M750.2535,309.93637l-18.82276,6.71878a1.19917,1.19917,0,1,1-.809-2.25779l.00269-.00094,18.82275-6.71878a1.19917,1.19917,0,1,1,.809,2.25778Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.76963,
    cy: 113.57172,
    r: 5,
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M484.03643,206.05581c5.03576-12.76968,12.99832-23.25127,24.838-30.7018a3.0182,3.0182,0,0,1,4.24-.44764l23.18667,18.75822a3.01822,3.01822,0,0,1,.44764,4.24l-24.838,30.70179a3.01819,3.01819,0,0,1-4.24.44767L484.48409,210.2958A3.01816,3.01816,0,0,1,484.03643,206.05581Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M487.92256,211.11863a3.01818,3.01818,0,0,1-.44766-4.24c5.03574-12.76975,12.99832-23.25132,24.838-30.70185a2.97943,2.97943,0,0,1,1.25782-.9013l-.45627-.36916a3.01825,3.01825,0,0,0-4.24.4476c-11.83966,7.45055-19.80225,17.9321-24.838,30.70186a3.01815,3.01815,0,0,0,.44763,4.24L507.67073,229.054a3.00481,3.00481,0,0,0,2.98221.4537Z",
    transform: "translate(-405.16496 -174.23664)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M518.56163,207.768,502.989,195.24082a1.19915,1.19915,0,0,1,1.50324-1.86871L520.065,205.89927a1.19916,1.19916,0,0,1-1.50327,1.86871Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M510.53694,192.87271l-3.426-2.756a1.19916,1.19916,0,0,1,1.50326-1.86871l3.426,2.756a1.19916,1.19916,0,0,1-1.50324,1.86873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M511.953,215.98336l-15.57269-12.52714a1.19916,1.19916,0,0,1,1.50326-1.86872l15.57266,12.52715a1.19916,1.19916,0,0,1-1.50326,1.86871Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M515.25728,211.87568l-15.57266-12.52714a1.19916,1.19916,0,1,1,1.4982-1.87279l.00506.00407L516.76055,210.007a1.19916,1.19916,0,0,1-1.4982,1.87279l-.00507-.00408Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.84504,
    cy: 9.59875,
    r: 5,
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M426.68325,355.53738C414.48213,339.3085,407.4301,321.16049,407.199,300.4703a4.46434,4.46434,0,0,1,2.71646-5.69134L451.50334,280.064a4.46432,4.46432,0,0,1,5.69132,2.71646l19.48422,55.06708a4.4643,4.4643,0,0,1-2.71643,5.69134l-41.58786,14.71494A4.46434,4.46434,0,0,1,426.68325,355.53738Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.07244,354.5559a4.46431,4.46431,0,0,1-5.69132-2.71643C418.18,335.61056,411.128,317.46258,410.89681,296.77239a4.40691,4.40691,0,0,1-.163-2.283l-.81839.28952a4.46442,4.46442,0,0,0-2.71652,5.69131c.23111,20.69016,7.28311,38.83817,19.48431,55.06708a4.46432,4.46432,0,0,0,5.69132,2.71643l41.58789-14.71485a4.44451,4.44451,0,0,0,2.87946-3.40832Z",
    transform: "translate(-405.16496 -174.23664)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M455.55605,313.33932l-27.84146,9.938a1.77374,1.77374,0,1,1-1.19257-3.341l27.84146-9.938a1.77373,1.77373,0,1,1,1.19257,3.341Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M430.56966,311.9299l-6.12512,2.18637a1.77374,1.77374,0,0,1-1.19257-3.341h0l6.12512-2.18637a1.77374,1.77374,0,0,1,1.19257,3.341Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M460.79888,328.02712l-27.84146,9.938a1.77373,1.77373,0,1,1-1.19257-3.341h0l27.84146-9.938a1.77373,1.77373,0,1,1,1.19257,3.341Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M458.17745,320.68322l-27.84146,9.938a1.77373,1.77373,0,1,1-1.19257-3.341h0l27.84146-9.938a1.77373,1.77373,0,1,1,1.19257,3.341Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.43714,
    cy: 113.7162,
    r: 7.3957,
    fill: "#3f3d56"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M701.12276,623.02239c-13.72656-.0697-26.38025-3.6961-37.61261-12.03411a3.01821,3.01821,0,0,1-1.9527-3.7901l9.08844-28.40589a3.01818,3.01818,0,0,1,3.7901-1.9527l37.61261,12.03412a3.01817,3.01817,0,0,1,1.9527,3.7901l-9.08844,28.40589A3.01816,3.01816,0,0,1,701.12276,623.02239Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M704.43471,617.56658a3.01817,3.01817,0,0,1-3.7901,1.9527c-13.72662-.06964-26.38025-3.6961-37.61261-12.03406a2.9791,2.9791,0,0,1-1.29559-.846l-.1789.559a3.01827,3.01827,0,0,0,1.95264,3.7901c11.23236,8.338,23.886,11.96441,37.61261,12.034a3.01816,3.01816,0,0,0,3.7901-1.95269l9.08844-28.40583a3.00491,3.00491,0,0,0-.657-2.94409Z",
    transform: "translate(-405.16496 -174.23664)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M690.21608,590.22045l-6.03753,19.05219a1.19915,1.19915,0,1,1-2.28919-.71515l.00293-.00934,6.03754-19.05218a1.19916,1.19916,0,0,1,2.28625.72448Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M679.23781,603.09454l-1.32825,4.19147a1.19914,1.19914,0,1,1-2.28918-.71515l.00293-.00934,1.32825-4.19147a1.19914,1.19914,0,1,1,2.28918.71515Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M700.26711,593.40557l-6.03754,19.05219a1.19914,1.19914,0,1,1-2.28918-.71515l.00293-.00934,6.03753-19.05218a1.19915,1.19915,0,1,1,2.28919.71514Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M695.2416,591.813l-6.03754,19.05219a1.19915,1.19915,0,1,1-2.28919-.71515l.00293-.00934,6.03754-19.05218a1.19914,1.19914,0,1,1,2.28918.71514Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.76989,
    cy: 419.57198,
    r: 5,
    fill: "#ccc"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.98605,
    cy: 397.31108,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-208.71342 872.83261) rotate(-75.77932)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 737.14242,
    cy: 397.09291,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-234.03163 839.86149) rotate(-75.77932)",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 777.33703,
    cy: 425.38953,
    rx: 3.60114,
    ry: 5.17661,
    transform: "translate(-231.14063 900.16976) rotate(-75.77932)",
    fill: "#ff6584"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 787.98249,
    cy: 436.99615,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-138.97892 997.34137) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 790.76542,
    cy: 458.204,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-157.58171 1018.95986) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 756.16513,
    cy: 417.78807,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-148.17378 948.64571) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 773.19683,
    cy: 411.38961,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-126.67451 959.88415) rotate(-83.62433)",
    fill: "#ff6584"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 752.21452,
    cy: 394.1031,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-128.14721 923.66471) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 454.98605,
    cy: 385.31106,
    rx: 3.6011,
    ry: 5.17661,
    transform: "translate(-435.45342 557.46376) rotate(-75.77932)",
    fill: "#fff"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.14242,
    cy: 385.09296,
    rx: 3.6011,
    ry: 5.17661,
    transform: "translate(-460.7717 524.49268) rotate(-75.77932)",
    fill: "#3f3d56"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 461.33704,
    cy: 413.38958,
    rx: 3.6011,
    ry: 5.17661,
    transform: "translate(-457.8807 584.80095) rotate(-75.77932)",
    fill: "#ff6584"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.98249,
    cy: 424.99618,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-407.96233 672.62836) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.76543,
    cy: 446.20393,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-426.56501 694.24679) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 440.16511,
    cy: 405.788,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-417.15711 623.9326) rotate(-83.62433)",
    fill: "#e6e6e6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 457.19683,
    cy: 399.38967,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-395.65795 635.17117) rotate(-83.62433)",
    fill: "#ff6584"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 436.21451,
    cy: 382.10316,
    rx: 3.27161,
    ry: 2.27591,
    transform: "translate(-397.13065 598.95172) rotate(-83.62433)",
    fill: "#3f3d56"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M675.9612,482.50015c-8.24878-10.97184-13.01642-23.24112-13.17267-37.22913a3.01822,3.01822,0,0,1,1.83649-3.84775l28.11627-9.9483a3.01818,3.01818,0,0,1,3.84772,1.83652l13.17267,37.22912a3.01818,3.01818,0,0,1-1.83649,3.84772l-28.11627,9.9483A3.01819,3.01819,0,0,1,675.9612,482.50015Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M682.309,481.8366a3.01817,3.01817,0,0,1-3.84772-1.83648c-8.24884-10.97187-13.01648-23.24115-13.17273-37.22913a2.97961,2.97961,0,0,1-.11017-1.54346l-.55328.19574a3.01827,3.01827,0,0,0-1.83655,3.84772c.15625,13.988,4.92389,26.25726,13.17273,37.22913a3.01817,3.01817,0,0,0,3.84772,1.83648l28.11627-9.94824a3.00475,3.00475,0,0,0,1.94672-2.30426Z",
    transform: "translate(-405.16496 -174.23664)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M695.48122,453.97137l-18.82275,6.71878a1.19916,1.19916,0,0,1-.80628-2.25873l18.82275-6.71878a1.19916,1.19916,0,0,1,.80628,2.25873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M678.5887,453.01849l-4.141,1.47812a1.19917,1.19917,0,1,1-.809-2.25778l.00269-.00095,4.141-1.47812a1.19916,1.19916,0,0,1,.80627,2.25873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M699.02571,463.90133,680.203,470.62011a1.19917,1.19917,0,1,1-.809-2.25778l.00269-.00095,18.82275-6.71878a1.19916,1.19916,0,0,1,.80627,2.25873Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M697.2535,458.93637l-18.82276,6.71878a1.19917,1.19917,0,1,1-.809-2.25779l.00269-.00094,18.82275-6.71878a1.19917,1.19917,0,1,1,.809,2.25778Z",
    transform: "translate(-405.16496 -174.23664)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.76963,
    cy: 262.57172,
    r: 5,
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeasFlow);
export default __webpack_public_path__ + "static/media/ideas-flow.1dee9d92187012c2814746da6cf07e6c.svg";
export { ForwardRef as ReactComponent };